import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=e2eeab6e"
import script from "./dashboard.vue?vue&type=script&lang=js"
export * from "./dashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/samuelscn/Área de Trabalho/veins/veins-api/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2eeab6e')) {
      api.createRecord('e2eeab6e', component.options)
    } else {
      api.reload('e2eeab6e', component.options)
    }
    module.hot.accept("./dashboard.vue?vue&type=template&id=e2eeab6e", function () {
      api.rerender('e2eeab6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/dashboard.vue"
export default component.exports